module.exports = __webpack_public_path__ + "static/img/timetable_widget_1.7ff6042.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/timetable_widget_1.png
// module id = B4B9
// module chunks = 11